import moment from "moment";
import { FileBase64 } from "../api/types-response";

export const fileBase64ToSrc = (file: FileBase64) => `data:${file.mime};base64,${file.data}`;
export const UTCstrdateToDate = (UTCdate: string) => new Date(UTCdate.substring(0, 19) + "Z");
export const dateFormat = (UTCdate: string) => (moment(UTCstrdateToDate(UTCdate))).format('DD.MM.YYYY, HH:mm:ss');
export const onlyDateFormat = (UTCdate: string) => (moment(UTCstrdateToDate(UTCdate))).format('DD.MM.YYYY');